// 统一 API 客户端：baseURL 来自构建时环境变量；鉴权用登录后保存的 JWT
import axios from 'axios';

const TOKEN_KEY = 'auth_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// 登录失效时通知 App 跳回登录页（App 挂载时注册）
let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

// 默认相对路径 /api：由 nginx 把 /api 反代到后端，浏览器同源请求（云端部署推荐）。
// 本地开发在 frontend/.env 里设 REACT_APP_API_BASE=http://localhost:5010/api 覆盖即可。
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE || '/api'
});

// 请求带上 JWT
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// 401 统一处理：清 token 并回登录页（登录接口本身的 401 不触发跳转，交由页面提示）
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || '';
    if (err.response?.status === 401 && !url.includes('/auth/login')) {
      clearToken();
      if (onUnauthorized) onUnauthorized();
    }
    return Promise.reject(err);
  }
);

export default api;
